import { useQuery } from '@tanstack/react-query';
import { attachmentsKeys } from './queryKeys';
export function useAttachmentsQuery(entityKey, ownerId, fetchAll) {
    return useQuery({
        queryKey: attachmentsKeys(entityKey).list(ownerId),
        queryFn: () => fetchAll(ownerId)
    });
}
